import { NavItem } from '@/app/types/navigation';
import { useAnalytics } from '@/app/utils/useAnalytics';
import cx from 'classnames';
import Link from 'next/link';
import { useRouter } from 'next/router';

import styles from './NavLink.module.scss';

export type NavLinkProps = Omit<NavItem, 'subItems'> & {
  className?: string;
  onNavItemClick?: () => void;
};

export const NavLink = ({
  onNavItemClick,
  label,
  to,
  trackEventName,
  id,
  testid,
  className,
}: NavLinkProps) => {
  const track = useAnalytics();
  const router = useRouter();
  const isActiveLink = router?.asPath === to;

  return (
    <Link
      prefetch={false}
      href={to}
      as={to}
      className={cx(
        styles.navLink,
        isActiveLink && styles.activeLink,
        label === 'Job Search' && styles.jobSearchLink,
        className,
      )}
      data-testid={testid}
      id={id}
      onClick={() => {
        trackEventName && track(trackEventName, {});
        onNavItemClick?.();
      }}
    >
      {label}
    </Link>
  );
};
